import { getAPI, postAPI, putAPI } from "../../api"
import { REACT_APP_CUSTOMERSETTINGS , REACT_APP_CUSTOMER } from "../../utils/common"


export async function updateCompanySettings(body: any) {
    const Details = putAPI(REACT_APP_CUSTOMERSETTINGS + '/customer-settings', body)
    return Details
}

export async function getUserDetailsForCustomer(user_id: string) {
    const Details = getAPI(REACT_APP_CUSTOMERSETTINGS + `/customer-user-details/${user_id}`)
     return Details
}

export async function listUserDetailsForCustomer(customerId: string) {
    const Details = getAPI(REACT_APP_CUSTOMERSETTINGS + `/customer-users-list/${customerId}`)
     return Details
}

export async function addNewCompanyUser(body: any) {
    const Details = putAPI(REACT_APP_CUSTOMERSETTINGS + '/customer-user', body)
    return Details
}

export async function edituserStatus(body: any) {
    const Details = putAPI(REACT_APP_CUSTOMERSETTINGS + '/user-status', body)
    return Details
}

export async function updateLocation(body: any){
    const Details = putAPI(REACT_APP_CUSTOMERSETTINGS + '/customer-location', body)
    return Details
}

export async function getCustomerForUserId(userLoginId: string) {
    const Details = getAPI( REACT_APP_CUSTOMER + `/user-customer-details/${userLoginId}`);
    return Details;
}

export async function updateRateInEmail(body: any){
    const Details = putAPI(REACT_APP_CUSTOMERSETTINGS + '/email-rate-flag', body)
    return Details
}

export async function getLocations(id: any){
    const Details = getAPI(REACT_APP_CUSTOMERSETTINGS + `/location-list/${id}`)
    return Details
}


